(function() {

    'use strict';

    angular.module('Services').factory('ComplianceLogsTable', ComplianceLogsTable);
    ComplianceLogsTable.$inject = [
        '$location',
        'ComplianceService',
        'TableLiteFactory',
        'toastr',
        '$filter'
    ];

    function ComplianceLogsTable(
        $location,
        complianceService,
        TableLiteFactory,
        toastr,
        $filter
    ) {
        return function (compliance) {
            const tableData = {
                config: {
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noTableFooter: false,
                    tableMinHeight: '10em',
                    // extraction: [{
                    //     type: 'csv'
                    // }]
                },
                headers: [{
                    label: 'User',
                    viewName: 'fullName',
                    width: '150px'
                }, {
                    label: 'Email',
                    viewName: 'email',
                    width: '150px'
                }, {
                    label: 'Approved',
                    viewName: 'signatureHash',
                    width: '150px'
                }, {
                    label: 'Date of Agreement',
                    viewName: 'agreementDate',
                    width: '150px'
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: function(callback) {
                        callback({content: compliance.complianceLogs});
                    },
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: compliance.id,
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(row, index) {
                    row.agreementDate = $filter('bbaDate')(row.agreementDate);
                    row.signatureHash = row.signatureHash ? 'Yes': 'No';
                    tableData.data.push(row);
                });
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/compliance/ComplianceLogsTable.js